<template>
    <card class="spaced typo">
        
        <h2 class="text-white mb-4">
            {{ $t('auth.my-account') }}
        </h2>

        <div class="row align-items-center">
            <div class="col-md-4 py-2">{{ $t('users.firstname') }}</div>
            <div class="col-md-8 text-white">{{ $auth.user.firstname }}</div>
        </div>

        <div class="row align-items-center">
            <div class="col-md-4 py-2">{{ $t('users.lastname') }}</div>
            <div class="col-md-8 text-white">{{ $auth.user.lastname }}</div>
        </div>

        <div class="row align-items-center">
            <div class="col-md-4 py-2">{{ $t('common.email') }}</div>
            <div class="col-md-8 text-white">{{ $auth.user.email }}</div>
        </div>

        <div class="row align-items-center">
            <div class="col-md-4 py-2">{{ $t('common.role') }}</div>
            <div class="col-md-8 text-white">{{ $auth.user.role ? $auth.user.role.name : '' }}</div>
        </div>

        <div class="row align-items-center">
            <div class="col-md-4 py-2">{{ $t('common.entity') }}</div>
            <div class="col-md-8 text-white">{{ $auth.user.entity ? $auth.user.entity.name : '' }}</div>
        </div>

        <div class="row align-items-center">
            <div class="col-md-4 py-2">{{ $t('common.active') }}</div>
            <div class="col-md-8 text-white">{{ $auth.user.active ? 'Yes' : 'No' }}</div>
        </div>

    </card>
</template>

<script>
    export default {
    }
</script>

<style scoped>

    .text-white {
        color: rgba(255, 255, 255, 0.8) !important;
    }

</style>
